<template>
    <b-modal
        title-tag="h2"
        title="Confirm to pay"
        :lazy="true"
        :id="modalRef"
        :ref="modalRef"
        no-close-on-esc
        no-close-on-backdrop
        @ok="proceed"
        @close="notConfirmed"
        @hide="close"
    >
        <p class="message">
            {{ message }}
        </p>

        <template v-slot:modal-footer>
            <modal-footer
                :isLoading="isLoading"
                cancel-title="Cancel Payment"
                second-title="Proceed"
                ok-title="No"
                second-variant="secondary"
                @cancel-action="cancelPayment"
                @second-action="proceed"
                @ok-action="notConfirmed"
            />
        </template>
    </b-modal>
</template>

<script>
export default {
    components: {
        ModalFooter: () => import("@/components/elements/modal-footer")
    },
    props: {
        modalRef: {
            type: String,
            default: "credit-convert-confirmation"
        }
    },
    data() {
        return {
            isLoading: false,
            message: "",
            isOpen: false,
            paidInvoices: []
        };
    },
    methods: {
        cancelPayment() {
            this.close();
            this.$emit("cancel-payment");
        },
        notConfirmed() {
            this.close();
            this.$emit("not-confirmed");
        },
        close() {
            this.isLoading = false;
            this.$refs[this.modalRef].hide();
        },
        async open(paidInvoices) {
            this.paidInvoices = paidInvoices;
            let invoiceWords = "";
            if (paidInvoices.length == 1) {
                invoiceWords = `The invoice #${paidInvoices[0].index} has`;
            } else if (paidInvoices.length == 2) {
                invoiceWords = `The invoices #${paidInvoices[0].index} and #${paidInvoices[1].index} have`;
            } else {
                const newArr = paidInvoices.slice(0, -2);

                invoiceWords = `The invoices ${newArr
                    .map(inv => {
                        return `#${inv.index}`;
                    })
                    .join(", ")}, #${
                    paidInvoices[paidInvoices.length - 2].index
                } and #${paidInvoices[paidInvoices.length - 1].index} have`;
            }
            this.message =
                invoiceWords +
                " been paid and the credit will be going to be created instead. Do you confirm to proceed?";
            this.$refs[this.modalRef].show();
        },
        async proceed() {
            this.close();
            this.$emit("proceed-payment");
        }
    }
};
</script>

<style scoped>
.message {
    margin-bottom: 10px;
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
}
</style>
